import { string, arrayOf, shape, number } from 'prop-types';
import portfolioPropType from './portfolioPropType';

export default shape({
  userId: string,
  userName: string,
  name: string,
  shortDescription: string,
  score: number,
  country: string,
  city: string,
  state: string,
  languages: arrayOf(string),
  projects: string,
  website: string,
  socials: arrayOf(
    shape({
      name: string,
      link: string,
    }),
  ),
  portfolio: arrayOf(portfolioPropType),
  about: string,
  additionalInfo: string,
});
